import { getCookie, getElement, ready, setCookie } from "./utils";
import { locationModal } from "./location-modal-window";
import { christianSliders } from "./sliders";
import { ScheduleEngineScripts } from "./schedule-engine-scripts";
import { cf7UtmData } from "./cf-7-utm-data";


ready(() => {
  cf7UtmData();
  christianSliders();
  ScheduleEngineScripts();
  // locationModal();
});



// function setEmailFromCookie(selectedEmail) {
//   // If selectedEmail is available, set it to inputs
//   if (selectedEmail) {
//     const formRecipients = document.querySelectorAll('input.form_recipient');
//     if (formRecipients != undefined && formRecipients != null) {
//       formRecipients.forEach((inputElement) => {
//         inputElement.value = decodeURIComponent(selectedEmail);
//       });
//     }
//   }
// }



// let setDefaultValueForCitySelect = () => {
//   // Get the saved city from cookies
//   var savedCity = getCookie('selectedCity');

//   // If there's a saved city, set it as selected
//   if (savedCity) {
//     var selectElement = document.getElementById('city-select');
//     for (var i = 0; i < selectElement.options.length; i++) {
//       if (selectElement.options[i].text === savedCity) {
//         selectElement.selectedIndex = i;
//         break;
//       }
//     }
//   }

// }
// export let citySelectEvent = () => {
//   // Listen for the change event on the select box
//   document.getElementById('city-select').addEventListener('change', function () {
//     // Get the selected option
//     var selectedOption = this.options[this.selectedIndex];

//     // Get the data attributes
//     var city = selectedOption.textContent;
//     var phone = selectedOption.getAttribute('data-phone');
//     var email = selectedOption.getAttribute('data-email');

//     replacePhoneNumbers(phone);
//     setEmailFromCookie(email);
//     replaceKeywordsWithCity(city);
//     // Set cookies
//     setCookie('selectedCity', city, 3);
//     setCookie('selectedPhone', phone, 3);
//     setCookie('selectedEmail', email, 3);


//   });
// }


// // Function to replace phone numbers
// function replacePhoneNumbers(newPhone) {
//   if (newPhone != null && newPhone !== undefined) {
//     // Convert new phone to a simple format
//     var simpleNewPhone = newPhone.replace(/[^0-9]/g, "");

//     // Convert simpleNewPhone to formatted string (317) 680 8033
//     var formattedNewPhone = `(${simpleNewPhone.slice(0, 3)}) ${simpleNewPhone.slice(3, 6)} ${simpleNewPhone.slice(6, 10)}`;

//     // Fetch all elements with the tag 'a'
//     var anchors = document.querySelectorAll("a");

//     // Regex for detecting phone numbers
//     var formattedOldPhoneRegex = /(\+?1?[-.\s]?(\()?[-.\s]?[0-9]{3}[-.\s]?(\))?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4})/g;

//     // Loop through each anchor tag
//     anchors.forEach(function (anchor) {
//       // Loop through each child node in the anchor
//       for (const node of anchor.childNodes) {
//         // Check if the node is a text node
//         if (node.nodeType === 3) {
//           var oldPhoneText = node.nodeValue;
//           if (oldPhoneText.match(formattedOldPhoneRegex)) {
//             // Replace only the phone number in the text node
//             node.nodeValue = oldPhoneText.replace(formattedOldPhoneRegex, formattedNewPhone);
//           }
//         }
//       }

//       var oldPhoneHref = anchor.getAttribute("href");
//       // Replace in href attribute
//       if (oldPhoneHref && oldPhoneHref.match(formattedOldPhoneRegex)) {
//         anchor.setAttribute("href", `tel:${formattedNewPhone}`);
//       }
//     });
//   }
// }

// function replaceKeywordsWithCity(cityName) {


//   if (!cityName) {
//     return; // Exit if cityName is not set
//   }

//   const keywords = [
//     'around Indianapolis',
//     'Bassett’s Indianapolis',
//     'chilly Indiana',
//     'chilly Plainfield',
//     'Cost in Indiana',
//     'in Indiana',
//     'in Indianapolis at',
//     'in Indianapolis, IN',
//     'in Indianapolis, Indiana',
//     'in Plainfield, IN',
//     'in Plainfield, Indiana',
//     'Plainfield, Indiana',
//     'Indiana home',
//     'Indiana’s reputable',
//     'Indianapolis Area',
//     'Indianapolis, IN',
//     'Indianapolis, Indiana',
//     'Indianapolis, Indiana’s',
//     'info@bassettservices.com',
//     'Local Indianapolis',
//     'local Indianapolis',
//     'my Indianapolis',
//     'Near Indianapolis',
//     'near Indianapolis',
//     'Near Indianapolis, Indiana',
//     'near Plainfield, Indiana',
//     'of Indianapolis',
//     'of Plainfield, Indiana',
//     'Plainfield documented',
//     'Plainfield experiences',
//     'Plainfield hover',
//     'Plainfield shivered',
//     'Plainfield, IN',
//     'Plainfield, Indiana, like',
//     'seasoned Indiana',
//     'Services in Indiana',
//     'Serving Plainfield, IN',
//     'skilled Indianapolis',
//     'the Indianapolis',
//     'the Indianapolis vicinity',
//     'the Indianapolis, Indiana Area',
//     'to Indianapolis',
//     'Trust Indianapolis, Indiana',
//     'unforgiving Indiana',
//     'West Indiana',
//     'why Indianapolis',
//     'your Indiana',
//     'Your Indianapolis, Indiana'
//   ];


//   function replaceText(node) {
//     let modifiedText = node.nodeValue;


//     keywords.forEach((keyword) => {
//       // Use word boundaries to prevent partial matches
//       const regExp = new RegExp('\\b' + keyword + '\\b', 'gi');

//       // Replace only if the entire keyword is found
//       modifiedText = modifiedText.replace(regExp, (match) => {
//         return match.replace(/Indianapolis|Plainfield|Indiana/gi, cityName);
//       });
//     });

//     // Remove the parts you don't want in the final text
//     const removableParts = [', IN', ', Indiana', ', Indiana’s', ', Indiana Area'];
//     removableParts.forEach((part) => {
//       const regExp = new RegExp(part, 'g');
//       modifiedText = modifiedText.replace(regExp, '');
//     });

//     node.nodeValue = modifiedText;
//   }




//   function walk(node) {
//     if (node.parentNode && node.parentNode.tagName === 'SELECT') {
//       return; // Skip this node and all its children if it's inside a select element
//     }
//     if (node.nodeType === 3) {
//       replaceText(node);
//     }
//     node = node.firstChild;
//     while (node) {
//       walk(node);
//       node = node.nextSibling;
//     }
//   }

//   function replaceDuplicateCity(cityName) {
//     if (!cityName) {
//       return; // Exit if cityName is not set
//     }
//     getElement('.location-modal-window--open').innerHTML = cityName;
//     console.log('replace dublicates')

//     function replaceText(node) {
//       const regExp = new RegExp(`${cityName},\\s*${cityName}`, 'gi'); // Regexp to match "Plainfield, Plainfield"
//       node.nodeValue = node.nodeValue.replace(regExp, cityName);
//     }

//     function walk(node) {
//       if (node.nodeType === 3) {
//         replaceText(node);
//       }
//       node = node.firstChild;
//       while (node) {
//         walk(node);
//         node = node.nextSibling;
//       }
//     }

//     walk(document.body);
//   }



//   walk(document.body);
//   console.log('replace city name text')
//   replaceDuplicateCity(cityName)
// }

// // Get the selected phone from cookies
// let selectedPhone = getCookie('selectedPhone');
// let selectedEmail = getCookie('selectedEmail');
// let selectedCity = getCookie('selectedCity');


// document.addEventListener('DOMContentLoaded', function (event) {
//   setDefaultValueForCitySelect();
//   // If there's a selected phone, replace all phone numbers on the page
//   if (selectedPhone) {
//     replacePhoneNumbers(selectedPhone);
//   }

//   if (selectedEmail) {
//     setEmailFromCookie(selectedEmail);
//   }
//   citySelectEvent();
//   replaceKeywordsWithCity(selectedCity);
// });